<template>
  <div class="row">
    <div class="col-lg-4 col-md-12">
      <Jumbotron>
        <div class="d-flex mt-2">
          <img src="../assets/svg/flag.svg" alt="" srcset="" width="30" class="mb-3" />
          <h4 class="heading ms-3">Employee Center</h4>
          <Button label="Create" class="qb-btn qb-btn-primary-md ms-auto" @onClick="toggleCreateUserModal()" />
        </div>
        <p class="sub-heading mb-2">
          Create and manage module. Task can be added to the module if the module is created or select the module to add
          task.
        </p>
      </Jumbotron>
      <Modal @close="toggleCreateUserModal" :modalActive="moduleCreateUserActive">
        <h4 class="modal-heading">Create Employee</h4>
        <div class="row">
          <div class="col-6">
            <div v-if="employee.profileImg">
              <img :src="employee.profileImg" alt="profile-image" class="profile-image" />
            </div>
            <input type="file" @change="onFilePicked" class="mt-3" />
          </div>
          <div class="col-12">
            <Input
              placeholder="Enter email"
              label="Employee Email *"
              class="mt-3"
              type="text"
              v-model="employee.emailId"
            />
          </div>
          <div class="col-6">
            <Input
              placeholder="Enter first name"
              label="Employee First Name *"
              class="mt-3"
              type="text"
              v-model="employee.firstName"
            />
          </div>
          <div class="col-6">
            <Input
              placeholder="Enter last name"
              label="Employee Last Name *"
              class="mt-3"
              type="text"
              v-model="employee.lastName"
            />
          </div>
          <div class="col-6">
            <DropDown
              :items="designationoption"
              :selectLabel="employee.designation || 'Select Designation'"
              @callBackValue="handleDesignation"
              v-model="designationSearchTerm"
              placeholder="Search for Designation"
              class="mt-3"
              label="Designation"
            />
          </div>
          <div class="col-6">
            <Input
              placeholder="Enter date of join"
              label="Date of Join *"
              class="mt-3"
              type="date"
              v-model="employee.dateOfJoining"
            />
          </div>
          <div class="col-6">
            <Input
              placeholder="Enter Mobile Number"
              label="Mobile Number *"
              class="mt-3"
              type="number"
              v-model="employee.mobile"
            />
          </div>
          <div class="col-6">
            <Select
              nullValueName="Select Location"
              label="Select Location"
              class="mt-3"
              :options="locationoption"
              v-model="employee.locationId"
            />
          </div>
          <div class="col-6">
            <Select
              nullValueName="Select Team"
              label="Select Team"
              class="mt-3"
              :options="teamoption"
              v-model="employee.teamId"
            />
          </div>
          <div class="col-6">
            <DropDown
              :items="managerOption"
              :selectLabel="managerName || 'Select Manager'"
              @callBackValue="handleManager"
              v-model="managerSearchTerm"
              placeholder="Search for Manager"
              class="mt-3"
              label="Manager"
            />
          </div>

          <div class="col-6">
            <Input
              placeholder="Enter password"
              label="Password *"
              class="mt-3"
              type="password"
              v-model="employee.password"
            />
          </div>
        </div>
        <Button
          label="Create"
          class="qb-btn qb-btn-primary-md mt-4"
          @onClick="createNewEmployee()"
          :disabled="!validateEmployee"
        />
      </Modal>
    </div>
    <div class="col-lg-8 col-md-12" v-if="1">
      <Card>
        <div>
          <div class="d-flex justify-content-between align-items-center m-2">
            <h4 class="title">Employee List</h4>
            <div class="d-flex justify-content-between align-items-center">
              <Input placeholder="Search Employee" type="text" v-model="employeeSearchTerm" />
              <!-- <Button label="Search" class="qb-btn qb-btn-primary-md ms-2" /> -->
            </div>
          </div>
          <hr class="divider" />
          <div class="m-2 employee-list-area">
            <EmployeeList v-for="(data, index) in userList" :key="index" :employee="data" />
          </div>
          <hr class="divider" />
          <div class="m-2">
            <Pagination :totalRecords="totalUserList" :pageSize="10" @pageChange="pageChange" />
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from "../components/CardComponent.vue";
import Button from "../components/ButtonComponent.vue";
import EmployeeList from "../components/EmployeeListComponent.vue";
import Jumbotron from "../components/JumbotronComponent.vue";
import Modal from "../components/ModalComponent.vue";
import Input from "../components/TextFieldComponent.vue";
import Select from "../components/SelectComponent.vue";
import Pagination from "../components/PaginationComponent.vue";
import DropDown from "../components/DropDownSearchComponent.vue";
import Vue from "vue";

import { designations } from "../config/designation";

import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapEmployeeGetters, mapActions: mapEmployeeActions } = createNamespacedHelpers("User");
export default {
  name: "EmployeePage",
  data() {
    return {
      moduleCreateUserActive: false,
      designationList: designations,
      roleOptions: [
        { value: "admin", label: "Admin" },
        { value: "user", label: "User" },
      ],
      // employeeSearchTerm: "",
      employee: {
        emailId: "",
        firstName: "",
        lastName: "",
        designation: "",
        dateOfJoining: "",
        password: "",
        locationId: "",
        teamId: "",
        mobile: "",
        profileImg: null,
        managerId: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userLocale: navigator.language,
      },
      user: {
        name: "",
        id: "",
        worksheet: "",
        worksheetId: "",
      },
      employeeSearchTerm: "",
      moduleSearchTerm: "",
      designationSearchTerm: "",
      managerSearchTerm: "",
      managerName: "",
    };
  },
  components: {
    Card,
    Button,
    EmployeeList,
    Jumbotron,
    Modal,
    Input,
    Select,
    Pagination,
    DropDown,
  },
  computed: {
    ...mapEmployeeGetters({
      userList: "getUserList",
      totalUserList: "getTotalUserListCount",
      userListOption: "getUserListOption",
      worksheets: "getWorkSheetOption",
      worksheetdata: "getCurrentUserWorkSheetList",
      locationoption: "getLocationOption",
      teamoption: "getTeamOption",
      designationoption: "getDesignationOption",
      managerOption: "getManagerOption",
    }),
    validateEmployee() {
      return (
        this.employee.firstName &&
        this.employee.lastName &&
        this.employee.designation &&
        this.employee.dateOfJoining &&
        this.employee.password &&
        this.employee.emailId &&
        this.employee.locationId &&
        this.employee.mobile &&
        this.employee.teamId &&
        this.employee.managerId
      );
    },
  },
  methods: {
    ...mapEmployeeActions({
      getUserList: "GET_USER_LIST",
      createEmployee: "CREATE_EMPLOYEE",
      getallworksheet: "GET_ALL_WORKSHEET",
      getworksheetbyid: "GET_WORKSHEET_BY_USER_ID",
      getLocationOptions: "GET_LOCATION_OPTION",
      getTeamOption: "GET_TEAM_OPTION",
      getDesignationOption: "GET_DESIGNATION_OPTION",
      getManagerOption: "GET_MANAGER_OPTION",
    }),
    toggleCreateUserModal() {
       this.employee = {
              emailId: "",
              firstName: "",
              profileImg: null,
              lastName: "",
              designation: "",
              dateOfJoining: "",
              password: "",
              mobile: "",
              teamId:"",
              locationId: "",
              timezone: "",
              userlocale: "",
              managerId: "",
            };
            this.employeeSearchTerm= "",
             this.moduleSearchTerm= "",
             this.designationSearchTerm= "",
            this.managerSearchTerm= "",
            this.managerName= "",
           this.moduleCreateUserActive = !this.moduleCreateUserActive;
    },
    createNewEmployee() {

      const { dateOfJoining, ...rest } = this.employee;

      this.createEmployee({
        payload: {
          dateOfJoining: this.formateDateToMilliSeconds(dateOfJoining),
          ...rest,
          role: "USER",
          // designation: this.employee.designation.replaceAll(" ", "_"),
        },
        successCallback: ({ data }) => {
          if (data.status === "OK") {
            Vue.$toast.success("Employee created successfully");
            this.toggleCreateUserModal();
            this.getUserList({ name: "",page:1 });
            this.employee = {
              emailId: "",
              firstName: "",
              profileImg: null,
              lastName: "",
              designation: "",
              dateOfJoining: "",
              password: "",
              mobile: "",
              teamId:"",
              locationId: "",
              timezone: "",
              userlocale: "",
              managerId: "",
            };
             this.employeeSearchTerm= "",
          this.moduleSearchTerm= "",
        this.designationSearchTerm= "",
      this.managerSearchTerm= "",
      this.managerName= "";
      this.getUserList({ name: this.employeeSearchTerm, page:1 });
          }
        },
        errorCallback: (err) => {
          Vue.$toast.error(err.message);
        },
      });
    },
    pageChange(page) {
      this.getUserList({ name: this.employeeSearchTerm, page });
    },
    handleUser({ label, value }) {
      this.user.name = label;
      this.user.id = value;
    },
    handleWorksheet({ label, value }) {
      this.user.worksheet = label;
      this.user.worksheetId = value;
    },
    onFilePicked(event) {
      const files = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => (this.employee.profileImg = reader.result);
    },
    handleDesignation({ label }) {
      this.employee.designation = label;
    },
    handleManager({ label, value }) {
      this.employee.managerId = value;
      this.managerName = label;
    },
  },
  watch: {
    "user.id"(val) {
      this.getallworksheet(val);
    },
    "user.worksheetId"(val) {
      this.getworksheetbyid(val);
    },
    employeeSearchTerm(val) {
      this.getUserList({ name: val });
    },
    moduleSearchTerm(name) {
      this.getAllModule({ name });
    },
    designationSearchTerm(value) {
      this.getDesignationOption({ designation: value });
    },
    managerSearchTerm(name) {
      this.getManagerOption({ name });
    },
  },
  created() {
    this.getUserList({ name: "" });
    this.getLocationOptions();
    this.getTeamOption();
    this.getDesignationOption({ designation: "" });
    this.getManagerOption({ name: "" });
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.employee-list-area {
  height: 560px;
  overflow-y: scroll;
}

.info-label {
  color: $light-500;
  font-size: $font-size-sm;
  font-weight: $font-weight-normal-1;
  margin: 0px;
}

.title {
  font-size: $font-size-lg;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.divider {
  border: 0.5px solid $light-500;
  margin: 0px;
}

.heading {
  font-size: $font-size-xxl;
  font-weight: 600;
}

.sub-heading {
  font-size: $font-size-md;
}

.modal-heading {
  font-size: $font-size-xxl;
  font-weight: 600;
}

.employee-card {
  background-color: $white;
  padding: 8px 12px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;
  border: 1px solid $light-200;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

  &:hover {
    background-color: $light-fade-200;
    cursor: pointer;
  }
}

.employee-title {
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-bottom: 0px;
}

.employee-subtitle {
  font-size: $font-size-sm;
  color: $light-600;
  font-weight: $font-weight-normal-1;
  margin-bottom: 0px;
}

.profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-right: 10px;
}
</style>
